module.exports = "participates"